import { render, staticRenderFns } from "./LoginModal.vue?vue&type=template&id=3b131b4c&scoped=true"
import script from "./LoginModal.vue?vue&type=script&lang=js"
export * from "./LoginModal.vue?vue&type=script&lang=js"
import style0 from "./LoginModal.vue?vue&type=style&index=0&id=3b131b4c&prod&lang=less&scoped=true"
import style1 from "./LoginModal.vue?vue&type=style&index=1&id=3b131b4c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b131b4c",
  null
  
)

export default component.exports